import React from 'react'
import { Routes, Route } from "react-router-dom";
import ProtectedRoutes from './ProtectedRoute';
import Login from '../pages/Login';
import NotFound from '../pages/NotFound';
import HomePage from '../pages/HomePage';
import Users from '../pages/Users';
import PaymentModes from '../pages/PaymentModes';
import Permissions from '../pages/Permissions';
import AuthRoute from './AuthRoute';
import { useSelector } from 'react-redux';
import { State } from '../redux/store';
import NotAuthorized from '../pages/NotAuthorized';
import Roles from '../pages/Roles';
import Expenses from '../pages/Expenses';
import Cabinets from '../pages/Cabinets';
import CreateCabinet from '../components/cabinets/CreateCabinet';
import UpdateCabinet from '../components/cabinets/UpdateCabinet';
import Doctors from '../pages/Doctors';
import RegistrationForm from '../components/doctors/abouts/registrationForm/RegistrationForm';
import AboutDoctor from '../components/doctors/abouts/AboutDoctor';
import ShowDiploms from '../components/diploms/ShowDiploms';
import Payments from '../pages/Payments';
import OrdreTable from '../pages/OrdreTable';
import AdsInfos from '../pages/AdsInfos';
import Assurances from '../pages/Assurances';
import ShowSupportAssurance from '../components/Assurances/supports/ShowSupportAssurance';
import Partners from '../pages/Partners';
import ShowSupportPartner from '../components/Partners/supports/ShowSupportPartner';
import ScientificDay from '../pages/ScientificDay';
import LegalAndRegText from '../pages/LegalAndRegText';
import News from '../pages/News';
import Instructions from '../pages/Instructions';
import Complaints from '../pages/Complaints';
import Moughataas from '../pages/Moughataas';

const AdminRoutes:React.FC = () => {
  const { userData } = useSelector((state: State) => state.login)

  return (
    <Routes>
      <Route element={<ProtectedRoutes />  }>

      <Route path="/" element={<HomePage />}/>
        <Route path="/role" element={<AuthRoute collectionName='ROLES' element={<Roles />}/>} />
        <Route path="/user" element={<AuthRoute collectionName='UTILISATEURS' element={<Users />}/>} />
        <Route path="/cabinet" element={<AuthRoute collectionName='CLINIQUES' element={<Cabinets />}/>} />
        <Route path="/cabinet/create" element={<AuthRoute permName='AJOUTER' collectionName='CLINIQUES' element={<CreateCabinet />}/>} />
        <Route path="/cabinet/update/:cabinetId" element={<AuthRoute permName='MODIFIER' collectionName='CLINIQUES' element={<UpdateCabinet />}/>} />
        
        <Route path="/doctor" element={<AuthRoute permName='AFFICHER' collectionName='DOCTEURS' element={<Doctors />}/>}/>
        <Route path="/doctor/:doctorId/about" element={<AboutDoctor />} >
          <Route path="regform" element={<AuthRoute collectionName='FORMULAIRE_D_INSCRIPTION' element={<RegistrationForm />}/>} />
          <Route path="diploms" element={<AuthRoute collectionName='DIPLOMES' element={<ShowDiploms />}/>} />
        </Route>
        
        <Route path="/payments" element={<AuthRoute collectionName='PAIEMENTS' element={<Payments />}/> } />
        <Route path="/ordre_table" element={<AuthRoute collectionName='TABLEAU_ORDRE' element={<OrdreTable />}/> } >
          <Route path="green" element={<AuthRoute collectionName='TABLEAU_ORDRE' element={<OrdreTable />}/> } />
          <Route path="yellow" element={<AuthRoute collectionName='TABLEAU_ORDRE' element={<OrdreTable />}/> } />
          <Route path="red" element={<AuthRoute collectionName='TABLEAU_ORDRE' element={<OrdreTable />}/> } />
        </Route>
        
        <Route path="/adsInfo" element={<AuthRoute collectionName='PUBLICITES_ET_INFORMATIONS' element={<AdsInfos />}/> } />
        <Route path="/paymentMode" element={<AuthRoute collectionName='MODE_PAIEMENTS' element={<PaymentModes />}/> } />
        <Route path="/expenses" element={<AuthRoute collectionName='DEPENSES' element={<Expenses />}/> }/>
        <Route path="/assurances" element={<AuthRoute collectionName='ASSURANCES' element={<Assurances />}/> }>
          <Route path=":AssId" element={<AuthRoute collectionName='ASSURANCES' element={<ShowSupportAssurance />}/> } />
        </Route>
        <Route path="/partners" element={<AuthRoute collectionName='PARTENAIRES' element={<Partners />}/> } >
          <Route path=":AssId" element={<AuthRoute collectionName='PARTENAIRES' element={<ShowSupportPartner />}/> } />
        </Route>
        <Route path="/scientificdays"  element={<AuthRoute collectionName='JOURNEE_SCIENTIFIQUE' element={<ScientificDay />}/> } />
        <Route path="/legal_and_reg_text"  element={<AuthRoute collectionName='TEXTE_JURIDIQUE_ET_REGLEMENTAIRES' element={<LegalAndRegText />}/> } />
        <Route path="/news"  element={<AuthRoute collectionName='ACTUALITES' element={<News />}/> } />
        <Route path="/instructions"  element={<AuthRoute collectionName='INSTRUCTIONS' element={<Instructions />}/> } />
        <Route path="/complaints"  element={<AuthRoute collectionName='PLAINTES' element={<Complaints />}/> } />
        <Route path="/moughataa"  element={<AuthRoute collectionName='MOUGHATAA' element={<Moughataas />}/> } />
        
        <Route path="/permissions" element={userData.dev ? <Permissions /> : <NotAuthorized />}/>
        
        <Route path="/login" element={<Login />}/>
        <Route path="*" element={<NotFound />}/>
      </Route>
    </Routes>
  )
}

export default AdminRoutes
